// src/components/Website.jsx
import React from "react";

/*
  NOTE:
  Yeh URLs Figma se extract hue assets hain. Agar aap local rakhna chahte ho
  to inko download karke /public/assets/ mein rakh ke src="/assets/filename.png" kar den.
*/
const imgBlueGridLines = "/assets/12d8c5e4-33c5-4aa0-a449-a73aa21ee83f.jpg";
const imgGrid3 = "/assets/95514d10-46f9-4c3e-9c54-bee71060a576.jpg";
const imgGridIndependence = "/assets/1b11b433-f8d2-46b8-9b00-057d59ef0ffe.jpg";
const imgWaterUsage = "/assets/c30256c2-3b5c-4fd1-bd49-5bf070061717.jpg";
const imgPhoto = "/assets/f3e30fe4-6ed7-4bf9-a659-087b4a4a107f.jpg";
const imgC2Ventures1 = "/assets/footer-right-logo.png";
const imgEllipse1 = "/assets/aa3552fe-23b9-40e9-9765-96974d0fd63d.svg";
const imgFrame872 = "/assets/68c12a6e-75f2-407e-bdac-7eff10f7fe8f.svg";
const imgFrame876 = "/assets/6997ce6c-a586-48d8-8b57-99f7c9ae9faf.svg";
const logoGroup = "/assets/tcc-logo.svg";
const logoGroup1 = "/assets/70e0106e-416a-4b3e-a876-b9abc28059e7.svg";
const menuIcon = "/assets/b85f4989-a91e-4e9c-83e8-6b3e8e2e6df5.svg";
const Cryogrid = "/assets/cyrogrid-logo.png";

function StatCard({ title, value, subtitle, accent }) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow p-5">
      <div className="text-xs font-semibold text-slate-500">{title}</div>
      <div className="mt-2 text-2xl font-bold text-slate-900">{value}</div>
      {subtitle && <div className="text-sm text-slate-400 mt-1">{subtitle}</div>}
      {accent && <div className="mt-3 text-sm font-semibold" style={{color: accent}}>{/* optional accent text */}</div>}
    </div>
  );
}

export default function Website() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-white to-slate-50 text-slate-900">
      {/* Top background frames (using extracted images) */}
     <header className="w-full bg-white/50 backdrop-blur-sm fixed top-0 left-0 z-50 shadow-sm px-6 md:px-24 py-4 flex items-center justify-between">
  {/* Left - Logo */}
  <div className="w-28">
    <img src={logoGroup} alt="logo" className="object-contain w-full h-full" />
  </div>

  {/* Center - Nav */}
  {/* <nav className="hidden md:flex gap-8 items-center text-lg font-semibold text-slate-800 mx-auto">
    <a className="hover:underline">Home</a>
    <a className="hover:underline">About Us</a>
    <div className="flex items-center gap-2">
      <a className="hover:underline">Pages</a>
      <img src={menuIcon} className="w-7 h-7" alt="caret" />
    </div>
  </nav> */}

  {/* Right - Button */}
  <a href="#contact-section" className="bg-[#0d3b66] text-white rounded-full px-6 py-2 font-semibold">
    Contact Us
  </a>
</header>

      <div className="relative overflow-hidden">
        <img style={{height: 700}} src={imgFrame872} alt="" className="w-full object-cover pointer-events-none" />
        

        {/* Hero */}
        <div className="absolute left-1/2 -translate-x-1/2 top-40 w-[92%] sm:w-[80%] lg:w-[70%] text-center">
          <h1 style={{marginTop: 30}} className="text-[#0d3b66] font-extrabold leading-tight text-4xl sm:text-5xl md:text-6xl">
            Power demand has outpaced infrastructure
          </h1>
          <p className="mt-4 text-lg text-slate-700 max-w-3xl mx-auto" style={{fontWeight: 500, fontSize: 22}}>
            AI requires energy that's local, flexible and ready to deploy fast.
          </p>

          {/* <p style={{
            color: '#1E293B',
            textAlign: 'center',
            fontFamily: 'Arial',
            fontSize: 69,
            fontStyle: 'normal',
            fontWeight: 600
          }}>Cryogrid™</p> */}
          <center><img src={Cryogrid} alt="logo" className="object-contain" style={{height: 150, marginTop: 25, width: '50%'}} /></center>

          {/* Cryogrid card */}
          <div className="mt-8 mx-auto bg-white rounded-xl shadow-md inline-flex items-center gap-5 px-8 py-6" style={{marginTop: 25}}>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#00b4d8]">200MW</div>
              <div className="text-sm text-slate-700" style={{fontWeight: 600, fontSize: 20, paddingTop: 0}}>in 24 months</div>
            </div>
            <div className="w-px h-16 bg-gray-700"></div>
            <div className="w-0 h-16 relative">
              <img src={logoGroup1} className="absolute inset-0 object-contain" alt="" />
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#f79c42]">1GW</div>
              <div className="text-sm text-slate-700" style={{fontWeight: 600, fontSize: 20, paddingTop: 0}}>by 2031</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main sections */}
      <main className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 -mt-6 pb-24">
      <p style={{
          color: "#0D3B66",
          textAlign: "center",
          fontFamily: 'Calibri',
          fontSize: "50px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "110%", // or "1.1
      }} className="mt-20">The Solution Stack</p>
        {/* Stats */}
        {/* <section className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          <StatCard title="Users" value="1,234" subtitle="+12% this week" accent="#00b4d8" />
          <StatCard title="Revenue" value="$8,940" subtitle="+5% this week" accent="#f79c42" />
          <StatCard title="Active" value="89" subtitle="Online right now" accent="#0d3b66" />
        </section> */}

        {/* Feature grid (the Solution Stack cards) */}
        <section className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left column card stack */}
          <div className="space-y-6">
            <div className="bg-white/60 border border-white/50 rounded-xl p-6" style={{boxShadow: "18px 15px 35px 0 rgba(0, 0, 0, 0.09)", backgroundColor: '#edebeb'}}>
              <div className="inline-flex items-center justify-center bg-white/10 rounded-md w-16 h-16 mb-4">
                <div className="text-white font-bold text-2xl bg-[#00B4D8] rounded-full w-12 h-12 flex items-center justify-center">1</div>
              </div>
              <h3 className="text-xl font-bold text-[#0d3b66]">Modular Fabrication</h3>
              <p className="mt-3 text-sm text-slate-700">
                Allows for rapid deployment to off- the-grid locations that require behind-the-meter energy solutions.
              </p>
            </div>

            <div className="bg-white/60 border border-white/50 rounded-xl p-6 h-[250px]" style={{boxShadow: "18px 15px 35px 0 rgba(0, 0, 0, 0.09)", backgroundColor: '#edebeb'}}>
              <div className="inline-flex items-center justify-center bg-white/10 rounded-md w-16 h-16 mb-4">
                <div className="text-white font-bold text-2xl bg-[#00B4D8] rounded-full w-12 h-12 flex items-center justify-center">4</div>
              </div>
              <h3 className="text-xl font-bold text-[#0d3b66]">Operations, Maintenance, and Reliability</h3>
              <p className="mt-3 text-sm text-slate-700">
                Continuous engineering support to ensure uptime, efficiency, and long-term asset reliability.
              </p>
            </div>
          </div>

          {/* Middle big card */}
          <div className="space-y-6">
            <div className="bg-white/60 border border-white/50 rounded-xl p-6" style={{boxShadow: "18px 15px 35px 0 rgba(0, 0, 0, 0.09)", backgroundColor: '#edebeb'}}>
              <div className="inline-flex items-center justify-center bg-white/10 rounded-md w-16 h-16 mb-4">
                <div className="text-white font-bold text-2xl bg-[#00B4D8] rounded-full w-12 h-12 flex items-center justify-center">2</div>
              </div>
              <h3 className="text-xl font-bold text-[#0d3b66]">Coordinated Supply Chain</h3>
              <p className="mt-3 text-sm text-slate-700">
                From sourcing and procurement to last-mile fuel delivery — ensuring dependable, energy-secure operations.
              </p>
            </div>
            <div className="bg-white/60 border border-white/50 rounded-xl p-6 h-[250px]" style={{boxShadow: "18px 15px 35px 0 rgba(0, 0, 0, 0.09)", backgroundColor: '#edebeb'}}>
              <div className="inline-flex items-center justify-center bg-white/10 rounded-md w-16 h-16 mb-4">
                <div className="text-white font-bold text-2xl bg-[#00B4D8] rounded-full w-12 h-12 flex items-center justify-center">5</div>
              </div>
              <h3 className="text-xl font-bold text-[#0d3b66]">Engineering, Procurement and Construction</h3>
              <p className="mt-3 text-sm text-slate-700">
                Purpose-built and scalable to meet evolving Al energy demands, combining technical precision with disciplined execution.
              </p>
            </div>
          </div>

          {/* Right column card stack */}
          <div className="space-y-6">
            <div className="bg-white/60 border border-white/50 rounded-xl p-6" style={{boxShadow: "18px 15px 35px 0 rgba(0, 0, 0, 0.09)", backgroundColor: '#edebeb'}}>
              <div className="inline-flex items-center justify-center bg-white/10 rounded-md w-16 h-16 mb-4">
                <div className="text-white font-bold text-2xl bg-[#00B4D8] rounded-full w-12 h-12 flex items-center justify-center">3</div>
              </div>
              <h3 className="text-xl font-bold text-[#0d3b66]">High Level Engineering</h3>
              <p className="mt-3 text-sm text-slate-700">
                Backed by proven design and process expertise, Tme Complexity supports projects from concept to commissioning.
              </p>
            </div>

            <div className="bg-white/60 border border-white/50 rounded-xl p-6 h-[250px]" style={{boxShadow: "18px 15px 35px 0 rgba(0, 0, 0, 0.09)", backgroundColor: '#edebeb'}}>
              <div className="inline-flex items-center justify-center bg-white/10 rounded-md w-16 h-16 mb-4">
                <div className="text-white font-bold text-2xl bg-[#00B4D8] rounded-full w-12 h-12 flex items-center justify-center">6</div>
              </div>
              <h3 className="text-xl font-bold text-[#0d3b66]">Automation and Controls</h3>
              <p className="mt-3 text-sm text-slate-700">
                Unified microgrid controls and DCIM for real-time optimization and failover. Secure remote monitoring with predictive analytics to maximize uptime.
              </p>
            </div>
          </div>
        </section>

        {/* Feature tiles with images */}
        <p style={{
          color: "#0D3B66",
          textAlign: "center",
          fontFamily: 'Calibri',
          fontSize: "50px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "110%", // or "1.1
      }} className="mt-20">Benefits</p>
        <section className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
  <div className="rounded-xl overflow-hidden relative">
    <img src={imgBlueGridLines} alt="" className="w-full h-48 object-cover" />
    <div className="absolute inset-0 bg-[#0d3b66]/70 flex items-center justify-center">
      <div className="text-white text-center font-bold px-4" style={{fontSize: 20}}>Utility-Grade Baseload with Quick Ramp</div>
    </div>
  </div>
  <div className="rounded-xl overflow-hidden relative">
    <img src={imgGrid3} alt="" className="w-full h-48 object-cover" />
    <div className="absolute inset-0 bg-[#0d3b66]/70 flex items-center justify-center">
      <div className="text-white text-center font-bold px-4" style={{fontSize: 20}}>Improved Water Usage Effectiveness</div>
    </div>
  </div>
  <div className="rounded-xl overflow-hidden relative">
    <img src={imgGrid3} alt="" className="w-full h-48 object-cover" style={{ transform: 'rotate(180deg)' }} />
    <div className="absolute inset-0 bg-[#0d3b66]/70 flex items-center justify-center">
      <div className="text-white text-center font-bold px-4" style={{fontSize: 20}}>Improved Power Usage Effectiveness</div>
    </div>
  </div>
  <div className="rounded-xl overflow-hidden relative">
    <img src={imgGridIndependence} alt="" className="w-full h-48 object-cover" />
    <div className="absolute inset-0 bg-[#0d3b66]/65 flex items-center justify-center">
      <div className="text-white text-center font-bold px-4" style={{fontSize: 20}}>Grid Independence</div>
    </div>
  </div>
  <div className="rounded-xl overflow-hidden relative">
    <img src={imgWaterUsage} alt="" className="w-full h-48 object-cover" />
    <div className="absolute inset-0 bg-[#0d3b66]/70 flex items-center justify-center">
      <div className="text-white text-center font-bold px-4" style={{fontSize: 20}}>Sustainability & Financial Viability</div>
    </div>
  </div>
</section>


        {/* Image + Contact form section */}
        <section className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch" id="contact-section" style={{marginTop: 100}}>
          <div className="rounded-xl overflow-hidden">
            <img src={imgPhoto} alt="production" className="w-full h-full object-cover min-h-[380px]" />
          </div>

          <div className="bg-[#00b4d8] rounded-xl p-8 flex flex-col justify-between">
          <form
            onSubmit={async (e) => {
              e.preventDefault(); // Stop redirect

              const formData = new FormData(e.target);

              await fetch("https://formsubmit.co/info@timecomplexity.io", {
                method: "POST",
                body: formData,
              });

              alert("✅ Your form has been submitted successfully!");
              e.target.reset();
            }}
          >
           <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_subject" value="New Contact Form Submission!" />
          <input type="hidden" name="_next" value="/" />

            <div>
              <h3 className="text-white text-2xl font-bold">Contact Us</h3>
              <p className="text-white/90 mt-3">Send us a message and our team will get back to you.</p>

              <div className="mt-6 space-y-4">
                <div>
                  <label className="text-white font-semibold">Full name</label>
                   <input
        className="w-full mt-2 p-3 rounded-full border border-white/40 bg-transparent text-white placeholder-white"
        name="Full Name"
        placeholder="Enter your full name"
        required
      />
                </div>
                <div>
                  <label className="text-white font-semibold">Email</label>
                  <input
        className="w-full mt-2 p-3 rounded-full border border-white/40 bg-transparent text-white placeholder-white"
        name="Email"
        type="email"
        placeholder="Enter your email"
        required
      />
                </div>
                <div>
                  <label className="text-white font-semibold">Message</label>
                  <textarea
        className="w-full mt-2 p-3 rounded-xl border border-white/40 bg-transparent text-white placeholder-white"
        name="Message"
        rows="4"
        placeholder="Enter your message"
        required
      ></textarea>
                </div>
              </div>
            </div>

            <button className="mt-6 bg-white rounded-full py-3 text-[#0d3b66] font-semibold" style={{width: '100%'}}>Submit</button>
            </form>
          </div>
        </section>
      </main>

      {/* Footer */}
     <footer className="bg-[#0d3b66] text-white mt-12">
  <div
    className="mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-8 bg-[#00B4D8]"
    style={{ paddingLeft: '5.5rem', paddingRight: '5.5rem' }}
  >
    {/* Left - Logo */}
    <div className="flex items-center justify-center md:justify-start w-full md:w-1/3">
      <div className="w-48 md:w-36">
        <img src={logoGroup} alt="logo" className="object-contain w-full h-auto" />
      </div>
    </div>

    {/* Center - Email */}
    <div className="flex items-center justify-center w-full md:w-1/3 text-center mt-4 md:mt-0">
      <a
        href="mailto:info@timecomplexity.io"
        className="font-semibold hover:underline"
        style={{
          textDecoration: 'underline',
          fontSize: 22,
          color: '#ededed',
        }}
      >
        info@timecomplexity.io
      </a>
    </div>

    {/* Right - Partner Logo */}
    <div className="flex items-center justify-center md:justify-end w-full md:w-1/3 mt-4 md:mt-0">
      <div className="w-60 sm:w-72 md:w-[20rem]">
        <img src={imgC2Ventures1} className="object-contain w-full h-auto" alt="partner" />
      </div>
    </div>
  </div>

  {/* Bottom Text */}
  <div>
    <p
      className="text-sm"
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        textAlign: 'center',
        fontSize: 20,
      }}
    >
      © 2025. All rights reserved.
    </p>
  </div>
</footer>

    </div>
  );
}
